import { useFormikContext } from "formik";
import React from "react";
import { useMount } from "react-use";
import CustomSelect from "../../../../../components/form/CustomSelect";
import Input from "../../../../../components/form/Input";
import { SourceEnum } from "../../../../../enums/template";
import { Template } from "../../../../../models";
import { getMediaLinkPlaceholder } from "../../../../../utils";

enum NoOfTopItems {
  FIFTEEN = 15,
  FOURTEEN = 14,
  THIRTEEN = 13,
  TWELVE = 12,
  ELEVEN = 11,
  TEN = 10,
  NINE = 9,
  EIGHT = 8,
  SEVEN = 7,
  SIX = 6,
  FIVE = 5,
  FOUR = 4,
  THREE = 3,
}

export const topItemsCountOptions = [
  {
    label: "15",
    value: NoOfTopItems.FIFTEEN,
    icon: "",
    description: "",
  },
  {
    label: "14",
    value: NoOfTopItems.FOURTEEN,
    icon: "",
    description: "",
  },
  {
    label: "13",
    value: NoOfTopItems.THIRTEEN,
    icon: "",
    description: "",
  },
  {
    label: "12",
    value: NoOfTopItems.TWELVE,
    icon: "",
    description: "",
  },
  {
    label: "11",
    value: NoOfTopItems.ELEVEN,
    icon: "",
    description: "",
  },
  {
    label: "10",
    value: NoOfTopItems.TEN,
    icon: "",
    description: "",
  },
  {
    label: "9",
    value: NoOfTopItems.NINE,
    icon: "",
    description: "",
  },
  {
    label: "8",
    value: NoOfTopItems.EIGHT,
    icon: "",
    description: "",
  },
  {
    label: "7",
    value: NoOfTopItems.SEVEN,
    icon: "",
    description: "",
  },
  {
    label: "6",
    value: NoOfTopItems.SIX,
    icon: "",
    description: "",
  },
  {
    label: "5",
    value: NoOfTopItems.FIVE,
    icon: "",
    description: "",
  },
  {
    label: "4",
    value: NoOfTopItems.FOUR,
    icon: "",
    description: "",
  },
  {
    label: "3",
    value: NoOfTopItems.THREE,
    icon: "",
    description: "",
  },
];

export default function TopItems() {
  const { values, errors, setFieldValue } =
    useFormikContext<Partial<Template>>();

  useMount(() => {
    if (!values.topItemsCount) {
      setFieldValue("topItemsCount", NoOfTopItems.TEN);
    }
  });

  const selectedTopItemsCount = topItemsCountOptions.find(
    (option) => option.value === values.topItemsCount
  );

  return (
    <div className="space-y-4">
      <Input
        label="Top Items Topic"
        name="topItemsTopic"
        value={values.topItemsTopic ?? ""}
        errorMessage={errors?.topItemsTopic as string}
        errorPosition="bottom-left"
        placeholder={getMediaLinkPlaceholder(SourceEnum.TOP_ITEMS)}
        onChange={({ target: { value } }) => {
          setFieldValue("topItemsTopic", value);
        }}
      />
      <div className="w-max">
        <CustomSelect
          label="How many top items to add?"
          placeholder="-"
          options={topItemsCountOptions}
          selected={selectedTopItemsCount}
          setSelected={(option) => {
            setFieldValue("topItemsCount", option?.value);
          }}
          maxMenuHeight={150}
          isClearable={false}
          className="max-w-24"
        />
      </div>
    </div>
  );
}
